import { copySuccess, standardError } from 'global/commonMessages';
import { notificationStore } from 'global/NotificationStore';

export const copyToClipboard = async (text) => {
	try {
		await navigator.clipboard.writeText(text);
		return true;
	} catch {
		return false;
	}
};

export const handleCopyRideId = async (text) => {
	const copied = await copyToClipboard(text);
	notificationStore.setNotification(copied ? copySuccess : standardError);
};
